import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { IFolderModel, NewFolder } from 'models/folder.model'
import Options from '../options/Options'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { useDispatch } from 'react-redux'
import * as fromActions from 'store/actions/folders.action'
import styles from '../List.module.scss'
import { useTranslation } from 'react-i18next'

interface IProps {
  item: IFolderModel
  edit: any
}

const useInput = (initialValue: any) => {
  const [value, setValue] = useState(initialValue)
  const onChange = (event: any) => setValue(event.target.value)

  return [value, onChange]
}

const Edit: React.FC<IProps> = ({ item, edit }) => {
  const { t } = useTranslation()

  const [name, setName] = useInput(item.name)

  const dispatch = useDispatch()

  const onEditClick = () => {
    if (name != '') {
      const folder = NewFolder(name, item.order)
      edit(false)
      dispatch({ type: fromActions.UPDATE_FOLDER, payload: { folder, id: item.id } })
    } else {
      ErrorToast(t('administration.folders.edit.validations.name'))
    }
  }

  return (
    <div className="border-bottom d-flex justify-content-between align-items-center p-2 pl-3">
      <div className={styles.inputContainer}>
        <FontAwesomeIcon size="1x" icon={faChevronDown} className={styles.createArrow} />
        <input type="text" value={name} onChange={setName} className={styles.inputFolders}/>
      </div>
      <div className="d-flex justify-content-between align-items-center w-25">
        <span className="text-muted" role="button" onClick={() => edit(false)}>
          {t('administration.folders.edit.buttons.cancel')}
        </span>
        <span className="text-success" role="button" onClick={onEditClick}>
          {t('administration.folders.edit.buttons.save')}
        </span>
        <Options item={null} onEditClick={null} onDeleteClick={null} disable={true} />
      </div>
    </div>
  )
}

export default Edit
